import TemplateCategorySelectBox from './TemplateCategorySelectBox';
import {connect} from '../../app/connect';
import {getTemplateCategories, getTemplateCategoriesEntitiesMap} from '../../app/templates/template-selectors';

const mapStateToProps = (state, ownProps) => {
  const selectedCategoryId = ownProps.selectedOptionId;
  const templateCategories = getTemplateCategories(state);
  const options = templateCategories.filter(category => category.isActive || category.id === selectedCategoryId);

  const templateCategoriesEntitiesMap = getTemplateCategoriesEntitiesMap(state);
  const value = templateCategoriesEntitiesMap[selectedCategoryId];

  return {
    value,
    options
  };
};

export default connect(mapStateToProps)(TemplateCategorySelectBox);
